import propTypes from 'prop-types';
import { useTheme } from 'styled-components';

const SvgEyeglassesIcon = ({ size, color, ...props }) => {
  const theme = useTheme();

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill={theme.colors[color] || color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.95663 12.516C6.3926 12.516 6.78607 12.3883 7.13704 12.1328C7.48802 11.8776 7.73559 11.5432 7.87975 11.1297L8.16829 10.2274C8.39579 9.54479 8.33621 8.91687 7.98954 8.34368C7.64288 7.77048 7.14906 7.48389 6.50809 7.48389H3.55454L3.95038 10.7468C4.01982 11.2489 4.24392 11.6692 4.62267 12.0078C5.00128 12.3466 5.44593 12.516 5.95663 12.516ZM14.0433 12.516C14.554 12.516 14.9986 12.3466 15.3773 12.0078C15.756 11.6692 15.9801 11.2489 16.0495 10.7468L16.4454 7.48389H13.5127C12.8717 7.48389 12.3766 7.77264 12.0273 8.35014C11.6778 8.9275 11.6169 9.55757 11.8445 10.2403L12.1202 11.1297C12.2643 11.5432 12.5119 11.8776 12.8629 12.1328C13.2138 12.3883 13.6073 12.516 14.0433 12.516ZM5.95663 13.766C5.13621 13.766 4.41697 13.4946 3.79892 12.9518C3.18086 12.409 2.82163 11.7247 2.72121 10.8989L2.29163 7.48389H1.52246V6.23389H6.50809C7.05503 6.23389 7.55927 6.37389 8.02079 6.65389C8.48232 6.93375 8.85093 7.31729 9.12663 7.80451H10.8941C11.1698 7.31729 11.5384 6.93375 12 6.65389C12.4615 6.37389 12.9657 6.23389 13.5127 6.23389H18.4775V7.48389H17.7083L17.2787 10.8989C17.1783 11.7247 16.8191 12.409 16.201 12.9518C15.5829 13.4946 14.8637 13.766 14.0433 13.766C13.3318 13.766 12.6934 13.563 12.1281 13.157C11.5629 12.751 11.1661 12.2131 10.9375 11.5433L10.6489 10.6537C10.6159 10.5405 10.5854 10.4224 10.5577 10.2995C10.5299 10.1767 10.5021 9.99673 10.4743 9.75951H9.52559C9.49781 9.96896 9.47003 10.1365 9.44225 10.262C9.41447 10.3874 9.38406 10.5068 9.351 10.6201L9.06246 11.5224C8.83913 12.1923 8.44357 12.7337 7.87579 13.1466C7.30788 13.5595 6.66816 13.766 5.95663 13.766Z"
        fill="inherit"
      />
      <path
        d="M9.00007 10C9.00007 11.6569 7.65692 13 6.00007 13C4.34321 13 3.00007 11.6569 3.00007 10C3.00007 8.34315 2.84315 6.5 4.5 6.5C6.15685 6.5 9.00007 8.34315 9.00007 10Z"
        fill="inherit"
      />
      <path
        d="M10.9999 10.5002C10.9999 12.1571 12.3431 13.5002 13.9999 13.5002C15.6568 13.5002 16.9999 12.1571 16.9999 10.5002C16.9999 8.84336 17.1568 7.00021 15.5 7.00021C12.5 6.50024 10.9999 8.84336 10.9999 10.5002Z"
        fill="inherit"
      />
    </svg>
  );
};

SvgEyeglassesIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
};

SvgEyeglassesIcon.defaultProps = {
  size: 20,
  color: 'porterPrimary',
};

export default SvgEyeglassesIcon;
